import { DxText } from '@dvag/design-system-react';
import i18next from 'i18next';
import { CustomerStatus, isCustomerStatus } from 'type/customerStatus';

import './style.css';

interface StatusConfig {
  getLabel: () => string;
  letter: string;
  modifier: string;
}

const statusConfig: Record<CustomerStatus, StatusConfig> = {
  Prospect: {
    getLabel: () => i18next.t('dashboard.customerStatus.prospect'),
    letter: 'I',
    modifier: 'prospect',
  },
  Customer: {
    getLabel: () => i18next.t('dashboard.customerStatus.customer'),
    letter: 'K',
    modifier: 'customer',
  },
  Legacy: {
    getLabel: () => i18next.t('dashboard.customerStatus.legacy'),
    letter: 'A',
    modifier: 'legacy',
  },
};

const unknownStatusConfig: StatusConfig = {
  getLabel: () => i18next.t('dashboard.customerStatus.unknown'),
  letter: '?',
  modifier: 'unknown',
};

interface CustomerStatusBadgeProps {
  compact?: boolean;
  status?: CustomerStatus | null;
}

export const CustomerStatusBadge = ({ compact = false, status }: CustomerStatusBadgeProps) => {
  const hasKnownStatus = isCustomerStatus(status);
  const config = hasKnownStatus ? statusConfig[status] : unknownStatusConfig;
  const label = config.getLabel();
  const testId = hasKnownStatus ? status.toLowerCase() : 'unknown';

  return (
    <span
      aria-label={label}
      className={`customer-status-badge customer-status-badge--${config.modifier}${
        compact ? ' customer-status-badge--compact' : ''
      }`}
      data-testid={`customer-status-${testId}`}
      title={label}
    >
      <DxText className="customer-status-badge__text" type="Infotext-Standard">
        {config.letter}
      </DxText>
    </span>
  );
};
